import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { Link } from 'react-router-dom';
import Image from '../Image';
import styles from './CallToActionLink.module.sass';

const CallToActionLink = ({ icon: Icon, text, bgColor, url, classes }) => {
  const moreStyles = {
    backgroundColor: bgColor ? bgColor : '',
  };

  return (
    <Link to={url}>
      <div className={cn(styles.ctaContainer, classes)} style={moreStyles}>
        <div style={{ marginRight: '4px' }}>
          <Icon color="#d67c00" />
        </div>
        <span className={styles.text}>{text}</span>
      </div>
    </Link>
  )
};

CallToActionLink.propTypes = {
  icon: PropTypes.func.isRequired,
  url: PropTypes.string.isRequired,
  text: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
  ]).isRequired,
  bgColor: PropTypes.string,
  classes: PropTypes.string,
};

export default CallToActionLink;
